import script from "./InviteAccept.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteAccept.vue?vue&type=script&setup=true&lang=js"

import "./InviteAccept.vue?vue&type=style&index=0&id=1472bbe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1472bbe6"]])

export default __exports__